<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
            <select v-model="showing">
                <option value="9">Top 10</option>
                <option value="4">Top 5</option>
                <option value="2">Top 3</option>
                <option value="all" selected>Show All</option>
            </select>
            <chart :options="chartOptions"  ref="chart"></chart>
            <span v-if="totalRides>0">Total de rides:{{totalRides}}</span>
        </b-overlay>

    </section>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)

    export default {
        name: "TotalRidesPerAirportAndChannel",
        components:{Chart},
        props: {

        },
        data(){
            let categoriesExample = ["CUN","PUJ","PVR"];
            let seriesExample = [
                { name:"Expedia",data:[50,42,82]},
                {name:"Booking.com",data:[42,58,64]},
                {name:"Mozio",data:[38,75,62]}
            ];
            return {
                totalRides:0,
                showing:"all",
                originalCategories:[],
                originalSeries:[],
                loading:false,
                exporting: {
                    enabled: true
                },
                codeReport : "rides-per-airport",
                chartOptions:{
                    title: {
                        text: 'Rides por Aeropuerto'
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            let detalle   = this.point.details??{};
                            for (let status in detalle ){
                                original.push(status+"= <b>"+detalle[status]+"</b><br/>");
                            }
                            original.push("Total de rides")
                            return original;
                        }
                    },
                    yAxis: {
                        title: {
                            text: 'Numero de rides'
                        }
                    },
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
                    chart:{
                        type:'column'
                    },
                    xAxis:{
                        type: 'category',
                        categories:categoriesExample,
                        max:null,
                    },
                    series: seriesExample,
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            },

                        }
                    }
                }
            }
        },
        methods:{

        },
        watch:{

        },
        mounted() {

        }
    }
</script>

<style scoped>

</style>